export const log = (from, message) => {
    console.log("["+new Date().toISOString()+" - "+from+"] - "+message);
}

export const getColor = (id) => {
    let colors = ["hsl(162, 70%, 50%)", "hsl(115, 70%, 50%)", "hsl(287, 70%, 50%)", "hsl(228, 70%, 50%)", "hsl(324, 70%, 50%)"];
    return colors[id%5];
}